import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const CTRL_API = `${BASE}/api/control`;

function getCookie(name) {
  const m = document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)");
  return m ? decodeURIComponent(m.pop()) : null;
}

const ctrlApi = axios.create({ baseURL: CTRL_API, withCredentials: true });

ctrlApi.interceptors.request.use((config) => {
  if (["post", "put", "patch", "delete"].includes((config.method || "").toLowerCase())) {
    const t = getCookie("mayr_ctrl_csrf");
    if (t) config.headers["X-CSRF-Token"] = t;
  }
  return config;
});

export function ctrlErr(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (d && d.error) return `${d.error}: ${(d.dependents || []).join(", ")}`;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(" ");
  return e?.message || "Error";
}

export default ctrlApi;
